import React, { useEffect, useState } from 'react';
import Modal from './Modal';

// Solo i timer sono modificabili a partita in corso: il server rifiuta ogni
// altra chiave. Prima accettava qualunque impostazione gia presente, password e
// budget compresi.

export default function AuctionSettingsModal({ show, settings, onSave, onClose }) {
    const [auctionTimer, setAuctionTimer] = useState(String(settings.auction_timer_x));
    const [bidTimer, setBidTimer] = useState(String(settings.bid_timer_y));

    useEffect(() => {
        setAuctionTimer(String(settings.auction_timer_x));
        setBidTimer(String(settings.bid_timer_y));
    }, [settings.auction_timer_x, settings.bid_timer_y]);

    const parsedAuction = Number.parseInt(auctionTimer, 10);
    const parsedBid = Number.parseInt(bidTimer, 10);
    const valid =
        Number.isInteger(parsedAuction) &&
        Number.isInteger(parsedBid) &&
        parsedAuction >= 3 &&
        parsedAuction <= 300 &&
        parsedBid >= 1 &&
        parsedBid <= parsedAuction;

    return (
        <Modal
            open={show}
            title="Impostazioni dell'asta"
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn btn--ghost" onClick={onClose}>
                        Chiudi
                    </button>
                    <button
                        type="button"
                        className="btn btn--primary"
                        disabled={!valid}
                        onClick={() => {
                            onSave({ auction_timer_x: parsedAuction, bid_timer_y: parsedBid });
                            onClose();
                        }}
                    >
                        Salva
                    </button>
                </>
            }
        >
            <div className="field">
                <label className="field-label" htmlFor="auctionTimer">
                    Durata dell&apos;asta su un giocatore (secondi)
                </label>
                <input
                    id="auctionTimer"
                    type="number"
                    className="input"
                    value={auctionTimer}
                    onChange={(event) => setAuctionTimer(event.target.value)}
                />
            </div>
            <div className="field">
                <label className="field-label" htmlFor="bidTimer">
                    Tempo rimesso a ogni rilancio (secondi)
                </label>
                <input
                    id="bidTimer"
                    type="number"
                    className="input"
                    value={bidTimer}
                    onChange={(event) => setBidTimer(event.target.value)}
                />
            </div>
            {!valid && (
                <p className="field-hint">
                    Durata fra 3 e 300 secondi; il tempo di rilancio non puo superarla.
                </p>
            )}
        </Modal>
    );
}
